import { Permission } from '@/lib/permissions/v1'
import {
    invoiceItemParamKey,
    invoiceParamKey,
    logParamKey,
    paymentItemParamKey,
    Route,
} from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    if (route.name.value === CompanyInvoiceRouteName.Index) {
        await route.addSortItem({
            column: 'number',
            direction: 'desc',
        })

        route.limit.value = 40
    }
    if (route.name.value === CompanyInvoiceRouteName.Show) {
        await route.addFilter({
            column: 'invoice_uuid',
            operator: '=',
            value: route.invoiceUuid.value,
        })

        await route.addSortItem({
            column: 'created_at',
            direction: 'desc',
        })
    }
}

export enum CompanyInvoiceRouteName {
    Index = 'company.invoices.index',
    Edit = 'company.invoices.edit',
    EditItem = 'company.invoices.items.edit',
    Show = 'company.invoices.show',
    Items = 'company.invoices.items',
    Logs = 'company.invoices.logs',
    LogDetails = 'company.invoices.logs.details',
    Send = 'company.invoices.send',
    ItemLogs = 'company.invoices.items.logs',
    ItemLogDetails = 'company.invoices.items.logs.details',
    Payments = 'company.invoices.payments',
    PaymentDetails = 'company.invoices.payments.details',
}

export default {
    path: 'invoices',
    name: CompanyInvoiceRouteName.Index,
    component: () => import('@/views/company/invoice/Index.vue'),
    meta: {
        label: 'Company Invoices',
        auth: true,
        permission: Permission.InvoiceViewAny,
    },
    children: [
        {
            path: `:${invoiceParamKey}/edit`,
            name: CompanyInvoiceRouteName.Edit,
            component: () => import('@/views/company/invoice/Index.vue'),
            meta: {
                label: 'Edit Invoice',
                auth: true,
                permission: Permission.InvoiceUpdate,
            },
        },
        {
            path: `:${invoiceParamKey}/send`,
            name: CompanyInvoiceRouteName.Send,
            component: () => import('@/views/company/invoice/Index.vue'),
            meta: {
                label: 'Send Invoice',
                auth: true,
                permission: Permission.InvoiceSend,
            },
        },
        {
            path: `:${invoiceParamKey}`,
            name: CompanyInvoiceRouteName.Show,
            component: () => import('@/views/company/invoice/Index.vue'),
            meta: {
                label: 'Invoice Details',
                auth: true,
                permission: Permission.InvoiceView,
            },
            children: [
                {
                    path: 'items',
                    name: CompanyInvoiceRouteName.Items,
                    component: () => import('@/views/company/invoice/Index.vue'),
                    meta: {
                        label: 'Invoice Items',
                        auth: true,
                        permission: Permission.InvoiceItemViewAny,
                    },
                    children: [
                        {
                            path: `:${invoiceItemParamKey}/edit`,
                            name: CompanyInvoiceRouteName.EditItem,
                            component: () => import('@/views/company/invoice/Index.vue'),
                            meta: {
                                label: 'Edit Invoice Item',
                                auth: true,
                                permission: Permission.InvoiceItemUpdate,
                            },
                        },
                        {
                            path: `:${invoiceItemParamKey}/logs`,
                            name: CompanyInvoiceRouteName.ItemLogs,
                            component: () => import('@/views/company/invoice/Index.vue'),
                            meta: {
                                label: 'Invoice Item Logs',
                                auth: true,
                                permission: Permission.EventViewAny,
                            },
                            children: [
                                {
                                    path: `:${logParamKey}`,
                                    name: CompanyInvoiceRouteName.ItemLogDetails,
                                    component: () => import('@/views/company/invoice/Index.vue'),
                                    meta: {
                                        label: 'Log Details',
                                        auth: true,
                                        permission: Permission.EventView,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: `:${invoiceParamKey}/logs`,
            name: CompanyInvoiceRouteName.Logs,
            component: () => import('@/views/company/invoice/Index.vue'),
            meta: {
                label: 'Invoice Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: CompanyInvoiceRouteName.LogDetails,
                    component: () => import('@/views/company/invoice/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
        {
            path: `:${invoiceParamKey}/payments`,
            name: CompanyInvoiceRouteName.Payments,
            component: () => import('@/views/company/invoice/Index.vue'),
            meta: {
                label: 'Invoice Payments',
                auth: true,
                permission: Permission.PaymentItemViewAny,
            },
            children: [
                {
                    path: `:${paymentItemParamKey}`,
                    name: CompanyInvoiceRouteName.PaymentDetails,
                    component: () => import('@/views/company/invoice/Index.vue'),
                    meta: {
                        label: 'Payment Details',
                        auth: true,
                        permission: Permission.PaymentItemView,
                    },
                },
            ],
        },
    ],
}
